import { Field, FieldProps } from 'formik';
import React, { ReactNode } from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { IErrorMessage } from '../components/errorMessage/errorMessage.type';
import InputField from '../components/InputField';
import ValueFormatters from './valueFormatters';
import { ValidatorRule } from '../validator/validatorRule.constants';
import { LastNameFieldValidator } from '../validator/lastNameFieldValidator';

interface ILastNameFieldProps {
    autoFocus?: boolean;
    intl: InjectedIntl;
    value?: string;
    required?: boolean;
    validatorRules?: ValidatorRule[];
}

class LastNameField extends React.Component<ILastNameFieldProps> {
    private readonly ID: string;
    private readonly LABEL_ID: string;
    private readonly ERROR_REQUIRED_ID: string;
    private readonly MAX_LENGTH: number;
    private lastNameFieldValidator: LastNameFieldValidator;

    constructor(props: ILastNameFieldProps) {
        super(props);

        this.ID = 'lastName';
        this.LABEL_ID = 'label.last_name';
        this.ERROR_REQUIRED_ID = 'error.last_name_required';
        this.MAX_LENGTH = 255;

        this.validate = this.validate.bind(this);
        this.renderInputField = this.renderInputField.bind(this);

        const { validatorRules = [ValidatorRule.EULastNameLengthRule] } = props;
        this.lastNameFieldValidator = new LastNameFieldValidator(validatorRules);
    }

    public render() {
        return <Field name={this.ID} validate={this.validate} render={this.renderInputField} />;
    }

    private validate(value?: string): IErrorMessage {
        const { required } = this.props;

        let errorMessage: IErrorMessage = '';

        if (!value && required) {
            return TranslationHelpers.getMessageDescriptor(this.ERROR_REQUIRED_ID);
        }

        if (value) {
            const err = this.lastNameFieldValidator.validate(value, this.LABEL_ID);
            if (err !== null) {
                errorMessage = err.message;
            }
        }

        return errorMessage;
    }

    private renderInputField({
        field,
        form: { touched, errors, setFieldValue, handleBlur },
    }: FieldProps): ReactNode {
        const { autoFocus, value, required } = this.props;
        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        const onBlur = (event: React.FocusEvent<any>) => {
            setFieldValue(this.ID, ValueFormatters.trimExtraSpaces(event.target.value));
            handleBlur(event);
        };

        return (
            <InputField
                autoComplete="family-name"
                labelMessage={TranslationHelpers.getMessageDescriptor(this.LABEL_ID)}
                type="text"
                id={this.ID}
                maxLength={this.MAX_LENGTH}
                name={this.ID}
                value={value}
                error={errorMessage}
                autoFocus={autoFocus}
                required={required}
                tabIndex={0}
                onBlur={onBlur}
            />
        );
    }
}

export default injectIntl(LastNameField);
